import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'OrganizedUnit/GetAllDirectionsOUCombo', method: 'GET', body: null, token: token })
}
